import React from 'react';
import { motion } from 'framer-motion';
export const AnimatedBackground: React.FC = () => {
  return <div className="fixed inset-0 z-0 bg-deep-navy" data-id="element-205">
      {/* Clean gradient base */}
      <div className="absolute inset-0 bg-gradient-to-br from-deep-navy via-signal-indigo/30 to-deep-navy" data-id="element-206" />

      {/* Animated grid pattern */}
      <svg className="absolute inset-0 w-full h-full opacity-20" data-id="element-207">
        <defs data-id="element-208">
          <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse" data-id="element-209">
            <path d="M 60 0 L 0 0 0 60" fill="none" stroke="rgba(250, 255, 49, 0.1)" strokeWidth="0.5" data-id="element-210" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" data-id="element-211" />
      </svg>

      {/* Floating geometric shapes */}
      <motion.div className="absolute top-1/3 right-20 w-24 h-24 border border-deploid-purple/30" animate={{
      y: [0, 15, 0],
      rotate: [0, -10, 0]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-212" />

      <motion.div className="absolute bottom-1/4 left-1/4 w-16 h-16 border border-electric-yellow/15 rounded-full" animate={{
      scale: [1, 1.2, 1],
      opacity: [0.3, 0.6, 0.3]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-213" />

      {/* Subtle scan lines */}
      <motion.div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: 'linear-gradient(transparent 50%, rgba(250, 255, 49, 0.02) 50%)',
      backgroundSize: '100% 4px'
    }} data-id="element-214" />

      {/* Radial glow accents */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-deploid-purple/10 rounded-full blur-3xl" data-id="element-215" />
    </div>;
};